// src/components/sections/About.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ImageLoader from "../ui/ImageLoader";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const images = [
  "/assets/images/Slider_001.jpg",
  "/assets/images/Slider_002.jpg",
  "/assets/images/Slider_003.jpg"
];

export default function About() {
  const { ref, isInView } = useScrollAnimation();
  const { t } = useTranslation();
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setCurrentImage((p) => (p + 1) % images.length), 4000);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      id="about"
      className="pt-16 sm:pt-16 md:pt-16 pb-20 sm:pb-20 md:pb-24 bg-accent scroll-mt-[72px]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-12 lg:gap-16 items-center">

          {/* LEFT: Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
            transition={{ duration: 0.8 }}
            className="relative justify-self-center lg:justify-self-start mt-0"
          >
            <div className="w-full max-w-[360px] sm:max-w-[400px] md:max-w-[480px] lg:max-w-[580px] aspect-square overflow-hidden rounded-lg shadow-xl mx-auto lg:mx-0">
              <ImageLoader
                src={images[currentImage]}
                alt={t("ourCulinaryJourney")}
                className="w-full h-full object-cover transition-all duration-500"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 sm:-bottom-8 sm:-left-8 w-2/3 h-2/3 z-[-1] bg-secondary rounded-lg" />
          </motion.div>

          {/* RIGHT: Text */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-none lg:pl-6 xl:pl-10 text-center lg:text-left"
            style={{ maxWidth: "75ch" }}
          >
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-black leading-tight tracking-tight mb-4 sm:mb-6">
              {t("aboutSection.paragraph1")}
            </h2>
            <p className="font-body text-base sm:text-lg md:text-xl text-black leading-relaxed mb-4 sm:mb-5">
              {t("aboutSection.paragraph2")}
            </p>
            <p className="font-body text-base sm:text-lg md:text-xl text-black leading-relaxed mb-6 sm:mb-8">
              {t("aboutSection.paragraph3")}
            </p>
                        <p className="font-body text-base sm:text-lg md:text-xl text-black leading-relaxed mb-6 sm:mb-8">
              {t("aboutSection.paragraph4")}
            </p>
                        <p className="font-body text-base sm:text-lg md:text-xl text-black leading-relaxed mb-6 sm:mb-8">
              {t("aboutSection.paragraph5")}
            </p>
            <div>
              <Link
                to="/our-story"
                className="inline-flex items-center rounded-full border border-secondary/70 px-5 sm:px-6 py-2.5 sm:py-3 text-secondary font-medium hover:bg-secondary/10 transition-colors"
              >
                {t("discoverOurStory")}
              </Link>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
